import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { WorkspaceApi } from "../../system-management/workspace/api/WorkspaceApi";
import { RootState } from "../../../store/store";
import { getListRegionAPI } from "../../system-management/qticket/api/ServicesManagementAPI";
import { getSLATypeAPI } from "../../system-management/qticket/api/ServicesManagementAPI";
import { AccountApi } from "../../../api/AccountApi";

export const fetchRegionInfo = createAsyncThunk(
  "selectionData/regionInfo",
  async (payload: { callback?: any }) => {
    const { callback } = payload;
    try {
      const { data } = await WorkspaceApi.getRegionInfo();
      return [...data];
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      callback && callback(false);
      throw error;
    }
  }
);

export const fetchObjectWorkspaceInfo = createAsyncThunk(
  "selectionData/objectWorkspaceInfo",
  async (payload: { callback?: any }) => {
    const { callback } = payload;
    try {
      const { data } = await WorkspaceApi.getObjectInfo();
      return [...data];
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      callback && callback(false);
      throw error;
    }
  }
);

export const fetchRacingGroupInfo = createAsyncThunk(
  "selectionData/racingGroupInfo",
  async (payload: { callback?: any }) => {
    const { callback } = payload;
    try {
      const { data } = await WorkspaceApi.getRacingInfo();
      return [...data];
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      callback && callback(false);
      throw error;
    }
  }
);

export const fetchTypeWorkspaceInfo = createAsyncThunk(
  "selectionData/typeWorkspaceInfo",
  async (payload: { callback?: any }) => {
    const { callback } = payload;
    try {
      const { data } = await WorkspaceApi.getTypeInfo();
      return [...data];
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      callback && callback(false);
      throw error;
    }
  }
);

export const fetchRolesInfo = createAsyncThunk(
  "selectionData/fetchRolesInfo",
  async (payload: { callback?: any }) => {
    const { callback } = payload;
    try {
      const { data } = await WorkspaceApi.getListRole();
      return [...data];
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      callback && callback(false);
      throw error;
    }
  }
);

export const fetchWorkspaceInfo = createAsyncThunk(
  "selectionData/fetchWorkspaceInfo",
  async (payload: { callback?: any }) => {
    const { callback } = payload;
    try {
      const { data } = await WorkspaceApi.getWorkspaceInfo();
      return { ...data[0] };
    } catch (error: any) {
      callback && callback(false);
      return [];
    }
  }
);

export const fetchRestaurantActive = createAsyncThunk(
  "selectionData/fetchRestaurantActive",
  async (payload: { callback?: any }) => {
    const { callback } = payload;
    try {
      const { data } = await WorkspaceApi.getRestaurantActiveInfo();
      return [...data];
    } catch (error: any) {
      callback && callback(false);
      return [];
    }
  }
);

export const fetchRegionsInTreeInfo = createAsyncThunk(
  "selectionData/fetchRegionsInTreeInfo",
  async (payload: { callback?: any }) => {
    const { callback } = payload;
    try {
      const { data } = await getListRegionAPI();
      return (
        data?.map((it: any) => ({ ...it, value: it.id, label: it.name })) || []
      );
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      callback && callback(false);
      throw error;
    }
  }
);

export const fetchSLATypesInfo = createAsyncThunk(
  "selectionData/fetchSLATypesInfo",
  async (payload: { callback?: any }) => {
    const { callback } = payload;
    try {
      const { data } = await getSLATypeAPI();
      return [...data];
    } catch (error: any) {
      // toast.error(error?.response?.data?.message);
      callback && callback(false);
      return [];
    }
  }
);

export const fetchRankInfo = createAsyncThunk(
  "selectionData/fetchRankInfo",
  async (payload: { callback?: any; userId?: number }) => {
    const { callback, userId } = payload;
    try {
      const { data } = await AccountApi.getAllowRankByUserId({
        user_id: userId,
      });
      if (data === "all") {
        return [data];
      }
      return [...data];
    } catch (error: any) {
      callback && callback(false);
      return [];
    }
  }
);

export const fetchAllAssigneeGroupInfo = createAsyncThunk(
  "selectionData/fetchAllAssigneeGroupInfo",
  async (payload: { callback?: any }) => {
    const { callback } = payload;
    try {
      const { data } = await AccountApi.getAssigneeGroupMetadata({
        app_ids: [5], // Phân hệ  G-Ticket
        page: 1,
        limit: 10000,
        status: [1], // Chỉ lấy nhóm đang hoạt động
      });
      return [...(data?.items || [])];
    } catch (error: any) {
      callback && callback(false);
      return [];
    }
  }
);

export async function getSelectionData(
  dispatch: any,
  userData: any,
  callback?: any
) {
  dispatch(
    fetchRegionInfo({
      callback,
    })
  );
  dispatch(
    fetchObjectWorkspaceInfo({
      callback,
    })
  );
  dispatch(
    fetchRacingGroupInfo({
      callback,
    })
  );
  dispatch(
    fetchTypeWorkspaceInfo({
      callback,
    })
  );
  dispatch(
    fetchRolesInfo({
      callback,
    })
  );
  dispatch(
    fetchWorkspaceInfo({
      callback,
    })
  );
  dispatch(
    fetchRestaurantActive({
      callback,
    })
  );
  dispatch(
    fetchRegionsInTreeInfo({
      callback,
    })
  );
  dispatch(
    fetchSLATypesInfo({
      callback,
    })
  );
  dispatch(
    fetchRankInfo({
      userId: userData?.id,
      callback,
    })
  );
  dispatch(
    fetchAllAssigneeGroupInfo({
      callback,
    })
  );
}

const initialState: any = {
  regionInfo: {
    data: [],
    status: "idle",
  },
  objectWorkspace: {
    data: [],
    status: "idle",
  },
  racingGroup: {
    data: [],
    status: "idle",
  },
  typeWorkspace: {
    data: [],
    status: "idle",
  },
  rolesInfo: {
    data: [],
    status: "idle",
  },
  workspaceInfo: {
    data: {},
    status: "idle",
  },
  restaurantsFromDAT: {
    data: [],
    status: "idle",
  },
  regionsInTreeInfo: {
    data: [],
    status: "idle",
  },
  slaTypesInfo: {
    data: [],
    status: "idle",
  },
  allowRankInfo: {
    data: [],
    status: "idle",
  },
  allAssigneeGroupInfo: {
    data: [],
    status: "idle",
  },
};

const selectionDataSlice = createSlice({
  name: "selectionData",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchRegionInfo.pending, (state) => {
        state.regionInfo.status = "loading";
      })
      .addCase(fetchRegionInfo.fulfilled, (state, action) => {
        state.regionInfo.status = "succeeded";
        state.regionInfo.data = action.payload;
      })
      .addCase(fetchRegionInfo.rejected, (state) => {
        state.regionInfo.status = "failed";
      })
      .addCase(fetchObjectWorkspaceInfo.pending, (state) => {
        state.objectWorkspace.status = "loading";
      })
      .addCase(fetchObjectWorkspaceInfo.fulfilled, (state, action) => {
        state.objectWorkspace.status = "succeeded";
        state.objectWorkspace.data = action.payload;
      })
      .addCase(fetchObjectWorkspaceInfo.rejected, (state) => {
        state.objectWorkspace.status = "failed";
      })
      .addCase(fetchRacingGroupInfo.pending, (state) => {
        state.racingGroup.status = "loading";
      })
      .addCase(fetchRacingGroupInfo.fulfilled, (state, action) => {
        state.racingGroup.status = "succeeded";
        state.racingGroup.data = action.payload;
      })
      .addCase(fetchRacingGroupInfo.rejected, (state) => {
        state.racingGroup.status = "failed";
      })
      .addCase(fetchTypeWorkspaceInfo.pending, (state) => {
        state.typeWorkspace.status = "loading";
      })
      .addCase(fetchTypeWorkspaceInfo.fulfilled, (state, action) => {
        state.typeWorkspace.status = "succeeded";
        state.typeWorkspace.data = action.payload;
      })
      .addCase(fetchTypeWorkspaceInfo.rejected, (state) => {
        state.typeWorkspace.status = "failed";
      })
      .addCase(fetchRolesInfo.pending, (state) => {
        state.rolesInfo.status = "loading";
      })
      .addCase(fetchRolesInfo.fulfilled, (state, action) => {
        state.rolesInfo.status = "succeeded";
        state.rolesInfo.data = action.payload;
      })
      .addCase(fetchRolesInfo.rejected, (state) => {
        state.rolesInfo.status = "failed";
      })
      .addCase(fetchRegionsInTreeInfo.pending, (state) => {
        state.regionsInTreeInfo.status = "loading";
      })
      .addCase(fetchRegionsInTreeInfo.fulfilled, (state, action) => {
        state.regionsInTreeInfo.status = "succeeded";
        state.regionsInTreeInfo.data = action.payload;
      })
      .addCase(fetchRegionsInTreeInfo.rejected, (state) => {
        state.regionsInTreeInfo.status = "failed";
      })
      .addCase(fetchWorkspaceInfo.pending, (state) => {
        state.workspaceInfo.status = "loading";
      })
      .addCase(fetchWorkspaceInfo.fulfilled, (state, action) => {
        state.workspaceInfo.status = "succeeded";
        state.workspaceInfo.data = action.payload;
      })
      .addCase(fetchWorkspaceInfo.rejected, (state) => {
        state.workspaceInfo.status = "failed";
      })
      // Get list restaurant active from DAT
      .addCase(fetchRestaurantActive.pending, (state) => {
        state.restaurantsFromDAT.status = "loading";
      })
      .addCase(fetchRestaurantActive.fulfilled, (state, action) => {
        state.restaurantsFromDAT.status = "succeeded";
        state.restaurantsFromDAT.data = action.payload;
      })
      .addCase(fetchRestaurantActive.rejected, (state) => {
        state.restaurantsFromDAT.status = "failed";
      })
      // SLA Types
      .addCase(fetchSLATypesInfo.pending, (state) => {
        state.slaTypesInfo.status = "loading";
      })
      .addCase(fetchSLATypesInfo.fulfilled, (state, action) => {
        state.slaTypesInfo.status = "succeeded";
        state.slaTypesInfo.data = action.payload;
      })
      .addCase(fetchSLATypesInfo.rejected, (state) => {
        state.slaTypesInfo.status = "failed";
      })
      // Rank Allow To Current User
      .addCase(fetchRankInfo.pending, (state) => {
        state.allowRankInfo.status = "loading";
      })
      .addCase(fetchRankInfo.fulfilled, (state, action) => {
        state.allowRankInfo.status = "succeeded";
        state.allowRankInfo.data = action.payload;
      })
      .addCase(fetchRankInfo.rejected, (state) => {
        state.allowRankInfo.status = "failed";
      })
      // All Assignee Group Info
      .addCase(fetchAllAssigneeGroupInfo.pending, (state) => {
        state.allAssigneeGroupInfo.status = "loading";
      })
      .addCase(fetchAllAssigneeGroupInfo.fulfilled, (state, action) => {
        state.allAssigneeGroupInfo.status = "succeeded";
        state.allAssigneeGroupInfo.data = action.payload;
      })
      .addCase(fetchAllAssigneeGroupInfo.rejected, (state) => {
        state.allAssigneeGroupInfo.status = "failed";
      });
  },
});

export const selectSelectionData = (state: RootState) => state.selectionData;
export const selectAllowRank = (state: RootState) =>
  state.selectionData?.allowRankInfo;
export const selectAssigneeGroup = (state: RootState) =>
  state.selectionData?.allAssigneeGroupInfo;
export default selectionDataSlice.reducer;
